import React from 'react';
import PropTypes from 'prop-types';
import {
  Input, Card, RadioButton, RadioButtonGroup,
} from '@ipc/ipc-components';

import { IdField } from '../styles';

const MainInfoComponent = ({
  values, receptacles, onInputChange, onReceptaclesChange,
}) => (
  <Card>
    <RadioButtonGroup name="receptacles" value={receptacles} className="RadioGroup" onChange={onReceptaclesChange}>
      <RadioButton value="all" label="All Receptacles" />
      <RadioButton value="consignment" label="Consignment ID" />
      <RadioButton value="despatch" label="Despatch ID" />
      <RadioButton value="receptacle" label="Receptacle ID" />
    </RadioButtonGroup>
    <IdField className="FormRowInline">
      <Input value={values[`${receptacles}Id`]} name={`${receptacles}Id`} onChange={onInputChange} huge disabled={receptacles === 'all'} className="Input StyledInput-Big" />
    </IdField>
  </Card>
);

MainInfoComponent.propTypes = {
  values: PropTypes.shape(),
  receptacles: PropTypes.string,
  onInputChange: PropTypes.func,
  onReceptaclesChange: PropTypes.func,
};

export default MainInfoComponent;
